module.exports = ".nav-item .disabled {\n  background-color: #e3e3e3;\n  cursor: none;\n  color: #9a9a9a;\n}\n"